import { NuggetProfile } from '@backrs_ui/common-ui';

import { useFetchPublicProfileInfoQuery } from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { Box, SxProps, Theme } from '@mui/material';

type UserSuggestion = Readonly<{
  id: string;
  relevance?: string;
}>;

type UserSuggestionItemProps = Readonly<{
  suggestion: UserSuggestion;
  onSelect: (userId: string, name: string) => void;
}>;

const UserSuggestionItem = ({ suggestion, onSelect }: UserSuggestionItemProps) => {
  const { data: response, isLoading } = useFetchPublicProfileInfoQuery({ userId: suggestion.id });

  const profile = response?.profile;
  const { publicProfile, careerOccupation, careerEmployer } = profile || {};

  const displayName =
    [publicProfile?.first_name, publicProfile?.last_name].filter(Boolean).join(' ') || '';
  const location = [publicProfile?.city, publicProfile?.state].filter(Boolean).join(', ');

  return (
    <Box id={`user-suggestion-${suggestion.id}`} sx={itemSx}>
      <NuggetProfile
        abbreviatedName={displayName}
        location={location}
        jobTitle={careerOccupation}
        employer={Array.isArray(careerEmployer) ? careerEmployer[0] : undefined}
        school=""
        role={publicProfile?.role}
        profileImageUrl={publicProfile?.profile_image}
        profileType="INTERNAL"
        contentSize="SMALL"
        onClick={() => onSelect(suggestion.id, displayName)}
        subText={suggestion.relevance}
        fitContent={true}
        actionParams={undefined}
        isHovered={false}
        isLoadingSubText={isLoading}
      />
    </Box>
  );
};

type UserSuggestionChatQuestionProps = Readonly<{
  users: UserSuggestion[];
  onSelect: (userId: string, name: string) => void;
}>;

export const UserSuggestionChatQuestion = ({
  users,
  onSelect,
}: UserSuggestionChatQuestionProps) => {
  if (users.length === 0) return null;

  return (
    <Box sx={listSx}>
      {users.map((user) => (
        <UserSuggestionItem key={user.id} suggestion={user} onSelect={onSelect} />
      ))}
    </Box>
  );
};

const listSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
});

const itemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: backrs.spacing['spacing-xxs'],
  borderRadius: backrs.radius['radius-4xl'],
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  border: `2px solid transparent`,
  '&:hover': {
    border: `2px solid ${backrs.colors['Brand/500']}`,
  },
  '&:active': {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
});
